// ./src/state/Sound.js

import Vue from 'vue';

const state = Vue.observable({
  soundOn: false,
});

export const getters = {
  isSoundOn: () => state.soundOn,
};

export const mutations = {
  toggleSound: () => { state.soundOn = !state.soundOn; },
  onSound: () => { state.soundOn = true; },
  offSound: () => { state.soundOn = false; },
};
